import { useEffect } from "react";
import Hero from "@/components/sections/Hero";
import SynirSection from "@/components/sections/SynirSection";
import ServicesSection from "@/components/sections/ServicesSection";
import SystemPreview from "@/components/sections/SystemPreview";
import WhyChooseUs from "@/components/sections/WhyChooseUs";
import HowWeWork from "@/components/sections/HowWeWork";
import Institutions from "@/components/sections/Institutions";
import Testimonials from "@/components/sections/Testimonials";
import CTASection from "@/components/sections/CTASection";
import ContactForm from "@/components/sections/ContactForm";

export default function Home() {
  useEffect(() => {
    document.title = "Áxis Saúde Digital — Tecnologia para hospitais e clínicas";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        "Soluções tecnológicas para hospitais, clínicas e instituições de saúde: BI hospitalar, IA, integração com Tasy, automação, cloud e mais."
      );
    }
  }, []);

  return (
    <div data-testid="home-page">
      <Hero />
      <SynirSection />
      <ServicesSection />
      <SystemPreview />
      <WhyChooseUs />
      <HowWeWork />
      <Institutions />
      <Testimonials />
      <CTASection />

      {/* Mini contact */}
      <section className="bg-white py-24 lg:py-32">
        <div className="max-w-5xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-12">
            <div className="lg:col-span-5">
              <p className="font-mono-axis text-xs uppercase tracking-widest text-[#3B82F6] mb-4">
                /08 · Contato
              </p>
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tighter font-semibold text-[#111827] leading-[1.05]">
                Vamos conversar sobre sua operação.
              </h2>
            </div>
            <div className="lg:col-span-7 flex items-end">
              <p className="text-base md:text-lg text-gray-600 leading-relaxed">
                Preencha o formulário e um especialista da Áxis retornará em até
                1 dia útil.
              </p>
            </div>
          </div>
          <ContactForm />
        </div>
      </section>
    </div>
  );
}
